module.exports = __webpack_public_path__ + "6b7d24801f72f3907a38a7d5763e84e3.pdf";